'use client';
import { Faq } from '@/types/fag';
import { Accordion, AccordionItem } from '@nextui-org/react';
import React from 'react';

interface Props {
  faqs: Faq[]
}

const QuestionsComponent = (props: Props) => { 
  const { faqs } = props;

    return (
    
    <div className='max-w-3xl w-dvw' >
      <Accordion selectionMode="multiple" variant="splitted">
      {faqs.map((item, i) => (
        <AccordionItem
          className='dark:text-gray-300'
          key={i}
          ria-label={`{AccordionItem-${i}}`}
          title={
            <div className="flex items-center gap-2">
              {item.icon && (
                <span className="material-symbols-outlined text-primary text-2xl">
                  {item.icon}
                </span>
              )}
              <span>{item.question}</span>
            </div>
          }
        >
        <div className='text-left overflow-hidden text-ellipsis py-4 dark:text-gray-400'>
          {item.answer}
        </div>
        </AccordionItem>
      ))}
      </Accordion>
    </div>
    
    )
}

export default QuestionsComponent;
